module.exports = __webpack_public_path__ + "img/cart.f3ab170b.svg";